import sha512 from './crypto/sha512';
import { Buffer } from 'buffer';
const crypto = require('crypto');
const _crypto = require('crypto');

const ALGO = 'aes-256-gcm';

let privateK = process.env.REACT_APP_PRIVATE_KEY ?? '';
let publicK = process.env.REACT_APP_PUBLIC_KEY ?? '';
// privateK = Buffer.from(privateK, 'base64').toString('utf8');
// publicK = Buffer.from(publicK, 'base64').toString('utf8');

console.log('privateK', { privateK });

const decrytRSA = (trama) => {
  try {
    // const decryptedMessage = _crypto.privateDecrypt(privateK, Buffer.from(trama, 'base64'));
    const decryptedData = crypto.privateDecrypt(
      {
        key: privateK,
        // In order to decrypt the data, we need to specify the
        // same hashing function and padding scheme that we used to
        // encrypt the data in the previous step
        padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
        oaepHash: 'sha256',
      },
      Buffer.from(trama, 'base64'),
    );

    console.log({ decryptedData });

    const rsaPrivateKey = {
      passphrase: privateK,
      padding: _crypto.constants.RSA_PKCS1_PADDING,
    };

    // const decryptedMessage = crypto.privateDecrypt(rsaPrivateKey, Buffer.from(trama, 'base64'));

    //return decryptedMessage.toString('utf8');

    return decryptedData.toString('utf8');
  } catch (error) {
    console.error('Erroor', error);
    return 'error';
  }
};

function decryptAES(data, key, iv) {
  const [val, tag] = data.split('.');
  const decipher = _crypto.createCipheriv(ALGO, Buffer.from(key, 'base64'), Buffer.from(iv, 'base64'));
  decipher.setAuthTag(Buffer.from(tag, 'base64'));
  let str = decipher.update(val, 'base64', 'utf8');
  str += decipher.final('utf8');
  return str;
}

function encryptAES(text, key, iv) {
  key = Buffer.from(key, 'base64');
  iv = Buffer.from(iv, 'base64');

  const cipher = crypto.createCipheriv(ALGO, key, iv);

  let encoded = cipher.update(text, 'ascii', 'base64');
  encoded += cipher.final('base64');
  const tag = cipher.getAuthTag();
  return `${encoded}.${tag.toString('base64')}`;
}
function makellaves(length) {
  // let result = '';
  // const characters = 'abcdefghijkmnpqrtuvwxyzABCDEFGHJKMNPQRTUVWXYZ2346789';
  // const charactersLength = characters.length;

  let key = crypto.createHash('sha512')

  return key;

  // for (let i = 0; i < length; i++) {
  //   result += characters.charAt(Math.floor(Math.random() * charactersLength));
  // }
  // console.log('result:', result, result.length);
  // return result;
}

export function encriptarContrasenia(contrasenia) {
  return sha512.sha512(contrasenia);
}

export function encriptarTrama(trama) {
  const jsEncrip = crypto.publicEncrypt(publicK, Buffer.from(trama));
  return jsEncrip.toString('base64');
}

export const desencriptarRsa = (trama) => {
  try {
    return decrytRSA(trama);
  } catch (error) {
    return 'error';
  }
};

export function encriptarTramaAES(tramaEntrada) {
  try {
    let key = makellaves(44);
    let iv = makellaves(24);
    const Data = encryptAES(tramaEntrada, key, iv);
    key = encriptarTrama(key);
    iv = encriptarTrama(iv);
    return { Data, iv, key };
  } catch (error) {
    return { Data: '', iv: '', key: '' };
  }
}

export async function desencriptarTramaAES(tramaEntrada, key, iv) {
  let noencriptado;
  try {
    key = decrytRSA(key);
    iv = decrytRSA(iv);
    console.log('IV', { key, iv });
    noencriptado = await decryptAES(tramaEntrada, key, iv);
  } catch (error) {
    console.error(error);
  }
  if (!noencriptado) return '';
  else return JSON.parse(noencriptado);
}

//-------------------------------------
function ab2str(buf) {
  return String.fromCharCode.apply(null, new Uint8Array(buf));
}

function str2ab(str) {
  const buf = new ArrayBuffer(str.length);
  const bufView = new Uint8Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

const pemEncodedKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAy3Xo3U13dc+xojwQYWoJLCbOQ5fOVY8LlnqcJm1W1BFtxIhOAJWohiHuIRMctv7dzx47TLlmARSKvTRjd0dF92jx/xY20Lz+DXp8YL5yUWAFgA3XkO3LSJgEOex10NB8jfkmgSb7QIudTVvbbUDfd5fwIBmCtaCwWx7NyeWWDb7A9cFxj7EjRdrDaK3ux/ToMLHFXVLqSL341TkCf4ZQoz96RFPUGPPLOfvN0x66CM1PQCkdhzjE6U5XGE964ZkkYUPPsy6Dcie4obhW4vDjgUmLzv0z7UD010RLIneUgDE2FqBfY/C+uWigNPBPkkQ+Bv/UigS6dHqTCVeD5wgyBQIDAQAB
-----END PUBLIC KEY-----`;

function importRsaKey(pem) {
  // fetch the part of the PEM string between header and footer
  const pemHeader = '-----BEGIN PUBLIC KEY-----';
  const pemFooter = '-----END PUBLIC KEY-----';
  const pemContents = pem.substring(pemHeader.length, pem.length - pemFooter.length);
  // base64 decode the string to get the binary data
  const binaryDerString = window.atob(pemContents);
  // convert from a binary string to an ArrayBuffer
  const binaryDer = str2ab(binaryDerString);

  return window.crypto.subtle.importKey(
    'spki',
    binaryDer,
    {
      name: 'RSA-OAEP',
      hash: 'SHA-256',
    },
    true,
    ['encrypt'],
  );
}
